import {TabData, Wizard} from "../../_shared/wizard/Wizard";
import React, {useState} from "react";
import {Step1Selection} from "./move-members-wizard-steps/Step1Selection";
import {OrgUnit} from "../../../models/organization";
import {SearchedMember} from "../../../models/membership.models";
import {Step2Validation} from "./move-members-wizard-steps/Step2Validation";

interface Props {
    goBack: () => void
    organizationId: number
}

export const MoveMembersWizard: React.FC<Props> = ({goBack, organizationId}) => {

    const [form, setForm] = useState({
        destinationOrgUnit: {} as OrgUnit,
        members: [] as SearchedMember[]
    });

    const changeSelectedMembers = (selectedMembers: Map<string, SearchedMember>) => {
        if (selectedMembers) {
            setForm(f => ({
                destinationOrgUnit: {...f.destinationOrgUnit} as OrgUnit,
                members: (Array.from(selectedMembers, ([id, member]) => ({
                    ...member,
                })))
            }))
        }
    }

    const changeDestinationOrgUnit = (orgUnit: OrgUnit) => {
        if (orgUnit) {
            setForm(f => ({...f, destinationOrgUnit: {...orgUnit}}));
        }
    }

    const step1: TabData = {
        labelKey: 'Members.MoveMembers.Tabs.SelectMembers.Title',
        key: 'move-members-selection',
        preserveTab: true,
        isDisabled: true,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) =>
            <Step1Selection
                onClose={goBack}
                index={index}
                lastIndex={lastIndex}
                onChangeTab={onChangeTab}
                onChangeSelectedMembers={changeSelectedMembers}
                organizationId={organizationId}
            />
    }

    const step2: TabData = {
        labelKey: 'Members.MoveMembers.Tabs.Validation.Title',
        key: 'move-members-validation',
        preserveTab: true,
        isDisabled: true,
        childComponent: (index: number, lastIndex: number, onChangeTab: (newTab: number) => void) =>
            <Step2Validation
                onClose={goBack}
                index={index}
                lastIndex={lastIndex}
                onChangeTab={onChangeTab}
                organizationId={organizationId}
                onChangeDestinationOrgUnit={changeDestinationOrgUnit}
                form={form}
            />
    }


    return Wizard({tabs: [step1, step2]});
}
